package com.nonopn.skydome.common.app.pages.main.model.api

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class PulseType {
    @SerialName("ic")
    IC,

    @SerialName("cg")
    CG,

    @SerialName("all")
    ALL,
}
